import classNames from 'classnames';
import styles from './FooterHeading.module.css';
//#region [Props]
type FooterHeadingProps = {
	children: React.ReactNode;
    className?: string;
};
//#endregion

//#region [Component]
export default function FooterHeading({ children, className }: FooterHeadingProps) {
	return <div className={classNames(styles.SFooterHeading, className)}>{children}</div>;
}
//#endregion
